window.addEventListener("DOMContentLoaded", () => {
	let hamburger = document.querySelector('header .hamburger');
	let close_btn = document.querySelector('nav .close-btn');
	let nav = document.querySelector('nav');
	if(hamburger){
		hamburger.addEventListener('click', ()=>{
			nav.classList.toggle('active');
		})
		close_btn.addEventListener('click', ()=>{
			nav.classList.remove('active')
		})
	}
	window.addEventListener('click', (e)=>{
		if(!e.target.closest('nav') && !e.target.closest('header .hamburger')){
			nav.classList.remove('active')
		}
	})
});